export default __webpack_public_path__ + "static/media/best.edb93a78.png";